import cn from 'classnames';

import useFunnelMealPlan from 'hooks/useFunnelMealPlan';
import { TEMPO, FAMILY, STANDARD } from 'lib/constants';

const InternalSkipButton = ({ funnelPage, onSubmit, logout }) => {
  const mealPlan = useFunnelMealPlan();

  const getLogoutButtonStyle = funnelPage => {
    switch (funnelPage) {
      case 'Home Chef':
        return 'hover:bg-vegetarian-100';
      case 'Tempo':
        return 'hover:bg-tempo-blue-70';
      case 'Family':
        return 'hover:bg-keto-100';
      default:
        return 'hover:bg-vegetarian-100';
    }
  };

  const getButtonStyle = mealPlan => {
    switch (mealPlan) {
      case STANDARD:
        return 'hover:bg-vegetarian-100';
      case TEMPO:
        return 'hover:bg-tempo-blue-70';
      case FAMILY:
        return 'hover:bg-keto-100';
      default:
        return 'hover:bg-vegetarian-100';
    }
  };

  const buttonStyle = logout ? getLogoutButtonStyle(funnelPage) : getButtonStyle(mealPlan);

  return (
    <button
      className={cn(
        'mx-2 my-2 h-9 w-40 rounded-lg p-2 text-center text-xs font-medium shadow-md focus:outline-none',

        buttonStyle
      )}
      style={{ zIndex: 9999 }}
      type="submit"
      onClick={event => {
        event.stopPropagation();
        onSubmit(event);
      }}
    >
      {logout ? 'Log out to ' : 'Skip to '}
      {funnelPage === 'thankyou' ? 'thank you' : `${funnelPage}`}
    </button>
  );
};

InternalSkipButton.propTypes = {
  funnelPage: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  logout: PropTypes.bool,
};

export default InternalSkipButton;
